import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { LoginComponent } from './login/login.component';
import { MembershipRoutingModule } from './membership-routing.module';
import { DeleteProfileComponent } from './delete-profile/delete-profile.component';
import { SendOtpComponent } from './send-otp/send-otp.component';

@NgModule({
  declarations: [LoginComponent, DeleteProfileComponent, SendOtpComponent],
  imports: [MembershipRoutingModule, SharedModule],
})
export class MembershipModule {}
